function setupMarquee(root) {
  const viewport = root.querySelector('.announcement-marquee__viewport');
  const track = root.querySelector('[data-marquee-track]');
  const group = root.querySelector('[data-marquee-group]');
  const clone = root.querySelector('[data-marquee-clone]');

  if (!viewport || !track || !group || !clone) return;

  // Reset (utile in Theme Editor quando Shopify re-renderizza)
  clone.innerHTML = '';
  root.style.setProperty('--marquee-distance', '0px');

  const baseItems = Array.from(group.children);
  if (!baseItems.length) return;

  // Duplica gli item nel primo gruppo finché la riga è "abbastanza lunga"
  // (così con 1 o 2 annunci non vedi vuoti)
  const targetWidth = Math.ceil(viewport.clientWidth * 2);
  let guard = 0;

  const currentWidth = () => group.scrollWidth;

  while (currentWidth() < targetWidth && guard < 60) {
    for (const el of baseItems) {
      group.appendChild(el.cloneNode(true));
    }
    guard += 1;
  }

  // Clona l'intero gruppo una volta per ottenere loop perfetto
  clone.innerHTML = group.innerHTML;

  // Distanza di scorrimento = larghezza del primo gruppo
  const distance = group.scrollWidth;
  root.style.setProperty('--marquee-distance', `${distance}px`);

  // In caso di layout non pronto, riprova al prossimo frame
  if (!distance) {
    requestAnimationFrame(() => {
      const d2 = group.scrollWidth;
      root.style.setProperty('--marquee-distance', `${d2}px`);
    });
  }
}

function init() {
  document.querySelectorAll('[data-announcement-marquee]').forEach(setupMarquee);
}

function debounce(fn, wait = 150) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), wait);
  };
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// Recalc su resize
window.addEventListener('resize', debounce(init, 200));

// Theme editor: quando cambi contenuti, Shopify a volte re-renderizza
document.addEventListener('shopify:section:load', init);
document.addEventListener('shopify:section:reorder', init);
document.addEventListener('shopify:section:select', init);
document.addEventListener('shopify:block:select', init);
